import { CardType } from 'types/deck'

import { cardManaCostToElement, CardText, createTypeLine } from 'components/misc/customIcons/ManaSymbol/helpers'

import styles from './fromFace.module.scss'

type Props = {
  card: CardType
}

/**
 * Displays information taken from the front of the card for those who would rather read text, than text on an image.
 */
const FromFace = ({ card }: Props) => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        {card.name}
        {cardManaCostToElement(card)}
      </h2>

      <div className={styles.typeBox}>{createTypeLine(card)}</div>

      <div className={styles.cardText}>
        <CardText input={card.text} />
      </div>

      {card.flavor && <i> {card.flavor} </i>}
    </div>
  )
}

export default FromFace
